import { render, staticRenderFns } from "./transferPage.template.vue?vue&type=template&id=6b4c82d6&scoped=true&"
var script = {}
import style0 from "./transferPage.template.vue?vue&type=style&index=0&id=6b4c82d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4c82d6",
  null
  
)

export default component.exports